import { Card, Stack, Typography } from '@mui/material';

import { useChartColorDefinitions } from '@/components/charts/constants';
import { StackedHorizontalBarGroup } from '@/components/charts/StackedHorizontalBarGroup/StackedHorizontalBarGroup';
import { Tile } from '@/components/diagrams/components/Tile';
import { TileVariant } from '@/components/diagrams/components/Tile/types';

export function AdminBrandingPreview() {
  const chartColorDefinitions = useChartColorDefinitions();
  return (
    <Card variant="outlined" sx={{ p: 2 }}>
      <Typography variant="title-xl">Preview</Typography>
      <Stack spacing={2}>
        <Stack spacing={1}>
          <Typography variant="title-xl">Bar chart</Typography>
          <StackedHorizontalBarGroup
            bars={[
              {
                label: 'Current',
                sections: [
                  {
                    color: chartColorDefinitions.PRIMARY.backgroundColor,
                    sectionTextColor:
                      chartColorDefinitions.PRIMARY.contrastText,
                    value: 40,
                    groupName: 'In estate',
                  },
                  {
                    color: chartColorDefinitions.SECONDARY.backgroundColor,
                    sectionTextColor:
                      chartColorDefinitions.SECONDARY.contrastText,
                    value: 35,
                    groupName: 'Out of estate - family',
                  },
                  {
                    color: chartColorDefinitions.TERTIARY.backgroundColor,
                    sectionTextColor:
                      chartColorDefinitions.TERTIARY.contrastText,
                    value: 25,
                    groupName: 'Out of estate - charity',
                  },
                  {
                    color: chartColorDefinitions.NEGATIVE.backgroundColor,
                    sectionTextColor:
                      chartColorDefinitions.NEGATIVE.contrastText,
                    value: 25,
                    groupName: 'Tax',
                  },
                ],
              },
              {
                label: 'Target',
                sections: [
                  {
                    color: chartColorDefinitions.PRIMARY.backgroundColor,
                    sectionTextColor:
                      chartColorDefinitions.PRIMARY.contrastText,
                    value: 10,
                    groupName: 'In estate',
                  },
                  {
                    color: chartColorDefinitions.SECONDARY.backgroundColor,
                    sectionTextColor:
                      chartColorDefinitions.SECONDARY.contrastText,
                    value: 40,
                    groupName: 'Out of estate - family',
                  },
                  {
                    color: chartColorDefinitions.TERTIARY.backgroundColor,
                    sectionTextColor:
                      chartColorDefinitions.TERTIARY.contrastText,
                    value: 25,
                    groupName: 'Out of estate - charity',
                  },
                  {
                    color: chartColorDefinitions.NEGATIVE.backgroundColor,
                    sectionTextColor:
                      chartColorDefinitions.NEGATIVE.contrastText,
                    value: 50,
                    groupName: 'Tax',
                  },
                ],
              },
            ]}
            showBarLabels={true}
            showLegend={true}
            headerVariant="title-l"
            headerSpacing={2}
          />
        </Stack>
        <Stack spacing={1}>
          <Typography variant="title-xl">Estate waterfall tiles</Typography>
          <Stack direction="row" spacing={2}>
            <Stack spacing={2}>
              <Tile
                variant={TileVariant.Primary}
                lineOne="In estate"
                lineTwo="$1.5m"
              />
              <Tile
                variant={TileVariant.Primary}
                lineOne="In estate"
                lineTwo="$1.5m"
                isIconVariant
              />
            </Stack>
            <Stack spacing={2}>
              <Tile
                variant={TileVariant.Secondary}
                lineOne="Out of estate - family"
                lineTwo="$1.5m"
              />
              <Tile
                variant={TileVariant.Secondary}
                lineOne="Out of estate - family"
                lineTwo="$1.5m"
                isIconVariant
              />
            </Stack>
            <Stack spacing={2}>
              <Tile
                variant={TileVariant.Tertiary}
                lineOne="Out of estate - charity"
                lineTwo="$1.5m"
              />
              <Tile
                variant={TileVariant.Tertiary}
                lineOne="Out of estate - charity"
                lineTwo="$1.5m"
                isIconVariant
              />
            </Stack>
            <Stack spacing={2}>
              <Tile
                variant={TileVariant.Destructive}
                lineOne="Gift & estate tax"
                lineTwo="$1.5m"
              />
              <Tile
                variant={TileVariant.Destructive}
                lineOne="Gift & estate tax"
                lineTwo="$1.5m"
                isIconVariant
              />
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </Card>
  );
}
